import { render, staticRenderFns } from "./SalesProfitMarginsSupplierGroupProduct.vue?vue&type=template&id=75af864a&"
import script from "./SalesProfitMarginsSupplierGroupProduct.vue?vue&type=script&lang=js&"
export * from "./SalesProfitMarginsSupplierGroupProduct.vue?vue&type=script&lang=js&"
import style0 from "./SalesProfitMarginsSupplierGroupProduct.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports